// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Notification_Loading__2pxGc","Header":"Notification_Header__1kXhy","BellIcon":"Notification_BellIcon__2Ipsu"};